import React, { useState } from 'react';
import { toast } from 'sonner';
import { Panel } from '../../components/Primitives';
import { useAuth } from '../../contexts/AuthContext';
import { useTheme } from '../../contexts/ThemeContext';
import { useI18n } from '../../i18n/I18nContext';
import { api, errMsg } from '../../lib/api';

const inp = 'w-full h-11 px-3 rounded-lg bg-vj-charcoal border border-border text-sm text-foreground focus:border-vj-neon/60 focus:outline-none';

export default function Settings() {
  const { user, updateUser } = useAuth();
  const { theme, setTheme } = useTheme();
  const { lang, setLang, languages } = useI18n();
  const [name, setName] = useState(user?.name || '');
  const [country, setCountry] = useState(user?.country || '');

  const save = async () => {
    try {
      const { data } = await api.put('/auth/profile', { name, country, language: lang, theme });
      updateUser(data); toast.success('Profile saved');
    } catch (err) { toast.error(errMsg(err)); }
  };

  return (
    <div className="space-y-6 max-w-3xl" data-testid="settings-page">
      <Panel title="Profile">
        <div className="grid sm:grid-cols-2 gap-4">
          <div><label className="text-xs text-vj-grey">Full name</label><input value={name} onChange={(e) => setName(e.target.value)} className={`mt-1 ${inp}`} data-testid="settings-name" /></div>
          <div><label className="text-xs text-vj-grey">Email</label><input value={user?.email || ''} readOnly className={`mt-1 ${inp} opacity-70`} /></div>
          <div><label className="text-xs text-vj-grey">Country</label><input value={country} onChange={(e) => setCountry(e.target.value)} className={`mt-1 ${inp}`} data-testid="settings-country" /></div>
          <div><label className="text-xs text-vj-grey">Language</label>
            <select value={lang} onChange={(e) => setLang(e.target.value)} className={`mt-1 ${inp}`} data-testid="settings-language">
              {languages.map((l) => <option key={l.code} value={l.code}>{l.label}</option>)}
            </select>
          </div>
        </div>
        <button onClick={save} className="mt-5 h-11 px-6 rounded-lg bg-vj-neon text-vj-obsidian font-semibold text-sm vj-glow-green hover:-translate-y-0.5 transition-all" data-testid="settings-save">Save Changes</button>
      </Panel>

      <Panel title="Preferences">
        <div className="flex items-center justify-between py-2">
          <div><div className="text-sm">Theme</div><div className="text-xs text-vj-grey">Choose dark or light appearance</div></div>
          <div className="flex gap-2">
            {['dark', 'light'].map((th) => (
              <button key={th} onClick={() => setTheme(th)} className={`h-9 px-4 rounded-lg text-sm capitalize transition-colors ${theme === th ? 'bg-vj-neon/15 text-vj-neon border border-vj-neon/30' : 'border border-border text-vj-grey'}`} data-testid={`theme-${th}`}>{th}</button>
            ))}
          </div>
        </div>
      </Panel>
    </div>
  );
}
